module.exports = __webpack_public_path__ + "img/banner-list-1.69ea185c.svg";